import React from 'react';
import { Link } from "react-router-dom";

import { useRevalidationData } from '../../helper/UserRevalidationProgress';
import '../../stylesheets/revalidation.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faSquareXmark } from '@fortawesome/free-solid-svg-icons';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import trackerTease from '../../assets/images/checklist-blur.jpg';

function Gold() {

  const {  phlHours, totalHours, selectedQualifications, renewalDate, loading, feedback, reflective } = useRevalidationData();

     if (loading) return <div><FontAwesomeIcon icon={faSpinner} style={{position: "absolute", top: "5rem", left: "50%", transform: "translate(-50%, 0)", fontSize: "40px"}}/></div>;;

  return (
    <div>
      <div className="dashboard-body">
        <h1>YOUR REVALIDATION DASHBOARD</h1>
        <p className={!renewalDate ? "show error-message" : "hide"}>IMPORTANT! Please fill out your <Link to="/dashboard/details">revalidation details</Link>. Your app will not work if this is incomplete.</p>
      
        <div>
          <h3>YOUR PORTFOLIO SNAPSHOT</h3>
          <p>Here is your current revalidation log:</p>
          <ul style={{listStyle:"none", paddingLeft:"1rem"}}>
            <li>{totalHours >= 35 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{totalHours}/35 CPD hours</li>
            <li>{phlHours >= (Number(selectedQualifications) * 450) ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{phlHours}/{450 * Number(selectedQualifications)} practice hours</li>
            <li>{reflective.length >= 5 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{reflective.length}/5 reflective accounts</li>
            <li>{feedback.length >= 5 ? <FontAwesomeIcon icon={faSquareCheck} style={{paddingRight: "5px", fontSize:"0.8rem", color: "green"}}/> : <FontAwesomeIcon icon={faSquareXmark} style={{paddingRight: "5px", fontSize:"0.8rem", color:"red"}}/>}{feedback.length}/5 pieces of feedback</li>
          </ul>
        </div>
        
        <br></br>
        <div>      
          <h3>YOUR REVALIDATION CHECKLIST</h3>
          <img src={trackerTease} style={{width:"100%"}} alt="A blurred image of the 1664 Revalidation Tracker"/>
          <br></br>
          <br></br>
          <p>As you are a Gold member, you are not subscribed to the <strong>Revalidation Milestone Tracker</strong>.
          <br></br>
          If you would like to track and view your revalidation progress, please upgrade your revalidation subscription to <strong>Diamond</strong> or <strong>Platinum</strong>.</p>
        </div>
    
      </div>
    </div>

  )
}

export default Gold